<script setup lang="ts">
import ButtonLink from '@components/ButtonLink.vue';
import IconTimer from '@icons/ph_timer.svg';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
import { trans } from '@elements/translation';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { URL_IDEAL_LOCATION } from '@tools/routes/routes';
import { storeToRefs } from 'pinia';

const { isMobile } = storeToRefs(useScreensizeStore());
</script>

<template>
  <ButtonLink class="time-travel" :href="URL_IDEAL_LOCATION" :target="isMobile ? '_self' : '_blank'">
    <div class="time-travel__icon">
      <Icon :svg="IconTimer" :width="24" :height="24" />
    </div>
    <div class="time-travel__text">
      <Typography variant="caption" as="span">
        {{ trans('selection_item.time_travel.link') }}
      </Typography>
    </div>
  </ButtonLink>
</template>

<style scoped lang="scss">
@use '@styles/mixins' as *;

.time-travel {
  &__icon {
    display: flex;
  }

  &__text {
    @include fontCaption();
    overflow: hidden;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
